module.exports = __webpack_public_path__ + "static/media/copy.a8b51131.svg";